'use strict';

var React = require('react');
var _ = require('lodash');

var AllocationAssets = React.createClass({
    propTypes: {
        assetAllocations: React.PropTypes.array.isRequired
    },
    getInitialState: function() {
        return {
            isHidden: true
        };
    },

    toggleAllocations: function() {
        this.setState({
            isHidden: !this.state.isHidden
        });
    },

    render: function() {
        if (this.props.assetAllocations.length < 1) {
            return null; // don't show allocations if there are none
        }

        if (!this.state.isHidden) {
            return (
                <section className="investment-allocation-asset row">
                    <div className="col-xs-12 col-md-8 investment-allocation-asset__container">
                        <a className="investment-allocation-asset__button--hide" onClick={this.toggleAllocations}>Hide allocation</a>
                        {
                            _.map(this.props.assetAllocations, function (asset, idx) {
                                let key = 'assetAllocation_' + idx;
                                return (
                                    <div className="row investment-allocation-asset__item" key={key}>
                                        <div className="col-xs-8 col-md-5">
                                            <p className="investment-allocation-asset__name">{asset.description}</p>
                                        </div>
                                        <div className="col-xs-4 col-md-3">
                                            <p className="investment-allocation-asset__weight">{asset.assetAllocationPercent}%</p>
                                        </div>
                                    </div>)
                            })
                        }
                    </div>
                </section>
            )
        } else {
            return (<a className="investment-allocation-asset__button workItem__hidden" onClick={this.toggleAllocations}>Show allocation</a>);
        }
    }
});

module.exports = AllocationAssets;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/AllocationAssets.jsx